import { createContext, useContext } from "react"
import { CalloutVariation } from "./types"

export const CalloutContext = createContext<{ variation: CalloutVariation }>({
  variation: "success",
})
export const useCalloutContext = () => useContext(CalloutContext)
